/**
 * Traduz a classificacao do 502/409 de /route53/zones para linguagem acionavel.
 *
 * Sem isto, 503, 502 e "conta sem zona nenhuma" produziam a mesma tela vazia —
 * foi o que fez o AccessDenied da replataforma ser lido como "tenant nao
 * preparado" por dias (incidente 2026-08-06). A distincao que importa e entre
 * "voce tem o que fazer" e "e problema da plataforma".
 */
const MENSAGENS: Record<string, string> = {
  intermediate_assume_denied:
    'A plataforma não conseguiu assumir a role intermediária na conta DevOps. ' +
    'Não é problema deste tenant — acione o time de plataforma.',
  tenant_assume_denied:
    'A plataforma não conseguiu assumir a ConsoleAIZtnaProvisionRole na conta ' +
    'do tenant. O reparo está no aviso abaixo.',
  tenant_account_id_missing:
    'Este tenant não tem account_id cadastrado. Corrija o cadastro do tenant ' +
    'antes de seguir.',
  cross_account_not_configured:
    'A integração cross-account não está configurada nesta instalação. ' +
    'Acione o time de plataforma.',
}

const PADRAO =
  'Falha ao carregar as zonas Route53. Tente de novo; se persistir, acione o ' +
  'time de plataforma.'

/**
 * Classificações que o botão de reparo desta tela PODE resolver.
 *
 * `intermediate_assume_denied` fica fora de propósito: o 1º salto é na conta da
 * plataforma, e nenhum botão daqui mexe nele. Oferecer reparo ali seria repetir
 * o defeito que esta mudança conserta — remédio que não pode rodar.
 */
export const CLASSIFICACOES_DE_ASSUME: ReadonlySet<string> = new Set([
  'tenant_assume_denied',
  'tenant_session_unavailable',
])

/** Classificação crua do detail, ou null quando o erro não traz uma. */
export function classificacaoDoErro(err: unknown): string | null {
  const detail = (
    err as { response?: { data?: { detail?: unknown } } } | null
  )?.response?.data?.detail
  if (typeof detail === 'object' && detail !== null) {
    const c = (detail as { classification?: string }).classification
    if (c) return c
  }
  return null
}

export function zoneErrorMessage(err: unknown): string {
  const c = classificacaoDoErro(err)
  if (c && MENSAGENS[c]) return MENSAGENS[c]
  return PADRAO
}
